import { STRINGS } from '@/constants/strings';
import {
  avatarRule,
  birthDateRule,
  cityRule,
  emailRule,
  nameRule,
  optionalPhoneRule,
  playerHeightRule,
  requiredPhoneRule,
  zipCodeRule,
} from '@/validation';
import * as yup from 'yup';

export const MESSAGES = STRINGS.mutatePlayer.validation;

export const createPlayerSchema = (todayStart: Date) =>
  yup
    .object({
      firstName: nameRule(MESSAGES.fieldRequired),
      lastName: nameRule(MESSAGES.fieldRequired),
      playerHeight: playerHeightRule(MESSAGES.playerHeightMustBeNumber),
      gender: yup
        .string()
        .oneOf(['Male', 'Female'], MESSAGES.fieldRequired)
        .required(MESSAGES.fieldRequired),
      level: yup
        .string()
        .matches(/^level_([1-9]|10)$/)
        .required(MESSAGES.fieldRequired),
      parentFirstName: nameRule(MESSAGES.fieldRequired),
      parentLastName: nameRule(MESSAGES.fieldRequired),
      phoneNumber: requiredPhoneRule(MESSAGES.fieldRequired, MESSAGES.phoneNumberDigitsRange),
      countryCode: yup.string().optional().nullable(),
      altPhoneNumber: optionalPhoneRule(MESSAGES.altPhoneNumberDigitsRange),
      altCountryCode: yup.string().optional().nullable(),
      email: emailRule(MESSAGES.fieldRequired, MESSAGES.emailInvalid),
      country: yup.string().trim().defined(),
      city: cityRule(),
      state: yup.string().trim().defined(),
      zipCode: zipCodeRule(),
      birthDate: birthDateRule(
        MESSAGES.fieldRequired,
        MESSAGES.birthDateCannotBeFuture,
        todayStart,
      ),
      needClubs: yup
        .string()
        .required(MESSAGES.fieldRequired)
        .test('needClubs', MESSAGES.fieldRequired, value => value === 'yes' || value === 'no'),
      dominantHand: yup
        .string()
        .required(MESSAGES.fieldRequired)
        .test(
          'dominantHand',
          MESSAGES.fieldRequired,
          value => value === 'left' || value === 'right',
        ),
      avatar: avatarRule(MESSAGES.fieldRequired, MESSAGES.avatarTooLarge),
    })
    .required();
